<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading='loading'>
            <el-row>
                <div class="card-top is-hover-shadow">
                    <div class="card-top-left">
                        <div class="top">
                            <span>{{themeName}}</span>
                        </div>
                        <div class="bottom">
                            <div class="left">活动PR：
                                {{prNumber}}-{{prName}}
                            </div>
                            <div class="right">{{brandName}}</div>
                        </div>
                    </div>
                    <div class="card-top-right">
                        <div class="text-time">
                            <span>活动执行时间：</span>
                            <span>{{themeStartTime}}</span>
                            <span style="margin:0 10px;">至</span>
                            <span>{{themeEndTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="search">
                    <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <el-form-item class="item" prop="levelBu">
                            <el-select v-model="searchForm.levelBu" placeholder="BU" size="small" clearable>
                                <el-option
                                v-for="(key,value) in buOptions"
                                :key="value"
                                :label="getSplit(key)"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="levelRegion">
                            <el-select v-model="searchForm.levelRegion" placeholder="销售大区" size="small" clearable>
                                <el-option
                                v-for="(key,value) in regionOptions"
                                :key="value"
                                :label="getSplit(key)"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="levelCity">
                            <el-select v-model="searchForm.levelCity" placeholder="城市" size="small" clearable>
                                <el-option
                                v-for="(key,value) in cityOptions"
                                :key="value"
                                :label="getSplit(key)"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="channel">
                            <el-select v-model="searchForm.channel" placeholder="渠道" size="small" clearable>
                                <el-option
                                v-for="(key,value) in channelOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="type">
                            <!-- :disabled="typeDisabled" -->
                            <el-select v-model="searchForm.type" placeholder="形式" size="small" clearable >
                                <el-option
                                v-for="(key,value) in typeOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="level">
                            <!-- :disabled="levelDisabled" -->
                            <el-select v-model="searchForm.level" placeholder="级别" size="small" clearable >
                                <el-option
                                v-for="(key,value) in levelOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="blockName" >
                            <!-- <el-select v-model="searchForm.blockName" placeholder="街道名称 " size="small" clearable >
                                <el-option
                                v-for="(key,value) in blockOptions"
                                :key="value"
                                :label="key"
                                :value="key">
                                </el-option>
                            </el-select> -->
                            <el-input v-model="searchForm.blockName" placeholder="街区名称 " size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item  class="item-btn">
                            <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="item-select">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <div class="select-btn">
                        <!-- <DialogPop
                        @confirm="agreeAll()"
                        :marLeft="true"
                        isType="2"
                        btnText="批量同意"
                        centerText="是否确认批量同意？"
                        >
                        </DialogPop> -->
                        <DialogPop
                        @confirm="disagreeAll()"
                        @getRejectaccount="getRejectaccount"
                        :isReject="false"
                        isType="0"
                        btnText="批量拒绝"
                        centerText="是否确认批量拒绝？"
                        >
                        </DialogPop>
                    </div>
                </div>
                <div class="card-select" v-for="(item) in cardData" :key="item.activityPocId">
                    <div class="card-left">
                        <div class="left-select">
                            <el-checkbox v-model="item.isChecked" @change="changeItem(item.isChecked)"></el-checkbox>
                        </div>
                    </div>
                    <div class="card-right card-item">
                        <div class="top">
                            <div class="top-left" v-if=" !item.blockName">
                                <span>门店名称：</span>
                                <span>{{item.gpActivityPocDTOList[0].pocName}}</span>
                            </div>
                            <div class="top-left2" v-if=" item.blockName">
                                <div class="name-boc">
                                    <span v-if="item.gpThemeDetailDTO.pocRelateType == '0'">活动地点：</span>
                                    <span v-if="item.gpThemeDetailDTO.pocRelateType == '2'">街区名称：</span>
                                    <!-- <span>街区名称：</span> -->
                                    <span>{{item.blockName}}</span>
                                </div>
                                <div class="name-poc" v-if=" item.blockName">
                                    <span>{{getPocname(item.gpActivityPocDTOList)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="second">
                            <span v-if="item.buName">BU:</span>
                            <span v-if="item.buName" class="center">{{getSplit(item.buName)}}</span>
                            <span v-if="item.regionName" class="line">|</span>
                            <span v-if="item.regionName">销售大区:</span>
                            <span v-if="item.regionName" class="center">{{getSplit(item.regionName)}}</span>
                            <span v-if="item.cityName" class="line">|</span>
                            <span v-if="item.cityName">City:</span>
                            <span v-if="item.cityName"  class="center">{{getSplit(item.cityName)}}</span>
                            <span v-if="item.themeChannelName" class="line">|</span>
                            <span v-if="item.themeChannelName">渠道:</span>
                            <span v-if="item.themeChannelName" class="center">{{item.themeChannelName}}</span>
                            <span v-if="item.themeStyleName" class="line">|</span>
                            <span v-if="item.themeStyleName">形式:</span>
                            <span v-if="item.themeStyleName" class="center">{{item.themeStyleName}}</span>
                            <span v-if="item.themeLevelName" class="line">|</span>
                            <span v-if="item.themeLevelName">级别:</span>
                            <span v-if="item.themeLevelName" class="center">{{item.themeLevelName}}</span>
                        </div>
                        <div class="last">
                            <div class="last-center">
                                <div class="last-center1">
                                    <div  class="item-time" v-if="item.timeApprovalDTO && item.timeApprovalDTO.timeOldList">
                                        <div class="item-left"> 原活动日期：</div>
                                        <div class="item-right">
                                            <span style="margin-right:5px">{{ item.timeApprovalDTO.timeOldList.length}}天</span>
                                            <i class="el-icon-date" style="color:#409eff;cursor: pointer;margin: auto;" @click="clickDate1(item)"></i>
                                            <el-date-picker
                                            type="dates"
                                            :ref="'changeFocus1' + (item.activityId)"
                                            style="width:0px;overflow: hidden;"
                                            popper-class="elDatePicker1"
                                            value-format="yyyy-MM-dd"
                                            v-model="item.timeApprovalDTO.timeOldList"
                                            :picker-options="pickerOptionsNo()"
                                            placeholder="选择一个或多个日期"
                                            size="small"
                                            :clearable="false"
                                            :default-value="defauleTime"
                                            >
                                            </el-date-picker>
                                        </div>
                                    </div>
                                    <div  class="item-time"  v-if="item.timeApprovalDTO && item.timeApprovalDTO.timeNewList">
                                        <div class="item-left"> 修改后活动日期：</div>
                                        <div class="item-right">
                                            <span style="margin-right:5px">{{item.timeApprovalDTO.timeNewList.length}}天</span>
                                            <i class="el-icon-date" style="color:#409eff;cursor: pointer;margin: auto;" @click="clickDate2(item)"></i>
                                            <el-date-picker
                                            type="dates"
                                            :ref="'changeFocus2' + (item.activityId)"
                                            style="width:0px;overflow: hidden;"
                                            popper-class="elDatePicker2"
                                            value-format="yyyy-MM-dd"
                                            v-model="item.timeApprovalDTO.timeNewList"
                                            :picker-options="pickerOptionsNo()"
                                            placeholder="选择一个或多个日期"
                                            size="small"
                                            :clearable="false"
                                            :default-value="defauleTime"
                                            >
                                            </el-date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="last-right">
                                <div class="btn-right" @click="agree(item)" v-if="item.gpThemeDetailDTO.needSpr == '1'">同意申请</div>
                                <DialogPop
                                v-else
                                @confirm="agree(item)"
                                :marLeft="true"
                                isType="1"
                                btnText="同意申请"
                                centerText="是否确认同意申请？"
                                >
                                </DialogPop>
                                <DialogPop
                                @confirm="disagree(item)"
                                @getRejectaccount="getRejectaccount"
                                isType="0"
                                btnText="拒绝申请"
                                centerText="是否确认拒绝申请？"
                                :isReject="false"
                                >
                                </DialogPop>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cardData.length == 0">
                     <el-empty description="暂无数据"></el-empty>
                </div>
                <div class="pagination" v-if="cardData.length > 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                </div>
                <!-- <BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}">
                </BigImg> -->
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import { commonUtils } from '@/utils/common'
    import DialogPop from './components/dialog-pop.vue'
    import BigImg from './components/big-img.vue'
    import gameplanApi from '../../api/gameplan'
    export default {
      name: 'dateChange-approval-detail',
      components: {
        ContentHeader,
        DialogPop,
        BigImg,
      },
      data () {
        return {
            searchForm: {
                levelBu: '', // Bu
                levelRegion: '', // Region
                levelCity: '', // City
                channel: '' , // 渠道
                type: '', // 类型
                level: '', // 级别
                blockName: '',// 街道名称
                page: 1,
                pageSize: 10,
                total:0,
            },
            igniteOptions:{},
            themeId:'',
            themeStartTime:'',
            themeEndTime:'',
            themeChannels:'',
            brandName:'',
            themeName:'',
            prName: '',
            prNumber: '',
            cardData: [],
            buOptions: {},
            regionOptions:{},
            cityOptions:{},
            channelOptions:{},
            typeOptions:{},
            levelOptions:{},
            blockOptions:{},
            loading: false,
            activityId:'',
            photoVisible: false,
            bigImgUrl: "",
            typeDisabled: true,
            levelDisabled: true,
            pickerOptionsNo(row = {}) {
                return{
                    disabledDate (time) {
                        return true
                    }
                }
            },
            checkAll: false,
            isIndeterminate: false,
            defauleTime:'',
            rejectAccount:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
        'searchForm.channel': {
            handler (to, from) {
                this.getStyleMap()
                this.searchForm.type = ''
                this.searchForm.level = ''
            },
            deep:true,
            immediate:true
            },
        'searchForm.type': {
            handler (to, from) {
                this.getLevelMap()
                this.searchForm.level = ''
            },
            deep:true,
            immediate:true
        },
      },
      created () {
        this.themeId = this.$route.query.themeId
        this.themeStartTime = this.$route.query.themeStartTime
        this.themeEndTime = this.$route.query.themeEndTime
        this.themeChannels = this.$route.query.themeChannels
        this.brandName = this.$route.query.brandName
        this.themeName = this.$route.query.themeName
        this.prName = this.$route.query.prName
        this.prNumber = this.$route.query.prNumber
        this.activityId = this.$route.query.activityId
        this.init()
      },
      mounted () {},
      methods: {
        init () {
            // this.getIgniteoptions()
            this.beginActivityreturn()
        },
        // 理由
        getRejectaccount (val) {
            this.rejectAccount = val
        },
        // 点击图标显示日期组件
        clickDate1 (row) {
            let min = Math.min(...row.timeApprovalDTO.timeOldList.map(item => new Date(item)));
            // console.log(min,'min-date1');
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            this.$nextTick(()=>{
                this.$refs[`changeFocus1${row.activityId}`][0].focus()
            })
        },
        clickDate2 (row) {
            let min = Math.min(...row.timeApprovalDTO.timeNewList.map(item => new Date(item)));
            // console.log(min,'min-date12');
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            this.$nextTick(()=>{
                this.$refs[`changeFocus2${row.activityId}`][0].focus()
            })
        },
        getSplit (val) {
            return val.split('|')[0]
        },
        getPocname(pocArray) {
          if (!pocArray || pocArray.length === 0) {
            return ''
          }
          const arr = []
          pocArray.map(item => {
            if (item.pocName) {
              arr.push(item.pocName)
            }
          })
          return arr.join('、');
        },
        getImg (uri) {
            return commonUtils.getImageUrl(uri)
        },
        clickImg (uri) {
            this.photoVisible = true
            this.bigImgUrl =  commonUtils.getImageUrl(uri)
        },
        handleCurrentChange (val) {
          this.searchForm.page = val
          this.getActivityreturn()
        },
        async getStyleMap () {
            let params = {
                channelCode:this.searchForm.channel
            }
            const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
            if (data.resultCode === "0") {
                this.typeOptions = data.resultData.themeStyleMap || {};
            }
        },
        async getLevelMap () {
            let params = {
                styleCode:this.searchForm.type
            }
            const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
            if (data.resultCode === "0") {
                this.levelOptions = data.resultData.themeLevelMap || {};
            }
        },
        async getIgniteoptions () {
            const { data } = await gameplanApi.getGameplanConfigIgniteOptions();
            if (data.resultCode === "0") {
                this.igniteOptions = data.resultData.igniteOptions || {};
            }
        },
        async beginActivityreturn () {
            let params = {
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                'buCode':this.searchForm.levelBu,
                'regionCode':this.searchForm.levelRegion,
                'areaCode':this.searchForm.levelCity,
                'themeChannelCode':this.searchForm.channel,
                'themeStyleCode':this.searchForm.type,
                'themeLevelCode':this.searchForm.level,
                'blockName':this.searchForm.blockName,
                'themeId':this.themeId,
            }

            let res = await gameplanApi.getGamepalnTimechange(params);
            if (res.data.resultCode == '0') {
                let data = res.data.resultData
                this.searchForm.page = data.pageInfo.curPage
                this.searchForm.total = data.pageInfo.totalCounts
                this.buOptions = data.buCodeMap
                this.regionOptions = data.regionCodeMap
                this.cityOptions = data.areaCodeMap
                this.channelOptions = data.themeChannelCodeMap
                if (data.activityPocList !== null) {
                   let cardData = data.activityPocList
                    for (let item of cardData) {
                        let oldTimelist = []
                        let newTimelist = []
                        if (item.gpActivityTimeDTOList !== null) {
                            for (let item2 of item.gpActivityTimeDTOList) {
                                oldTimelist.push(item2.activityTime)
                            }
                        }
                        if (item.waitApprovalTimeDTOList !== null) {
                            for (let item2 of item.waitApprovalTimeDTOList) {
                                newTimelist.push(item2.activityTime)
                            }
                        }
                        item.oldTimelist = oldTimelist
                        item.newTimelist = newTimelist
                        // item.isChecked = true
                        item.isChecked = false
                    }
                    this.cardData = cardData
                    // this.isIndeterminate = false
                    // this.checkAll = true
                    this.isIndeterminate = false
                    this.checkAll = false
                } else {
                    this.cardData = []
                    // this.$router.go(-1)
                }
            } else {
                console.log('接口error');
            }
        },
        // 详情搜索
        async getActivityreturn () {
            let params = {
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                'buCode':this.searchForm.levelBu,
                'regionCode':this.searchForm.levelRegion,
                'areaCode':this.searchForm.levelCity,
                'themeChannelCode':this.searchForm.channel,
                'themeStyleCode':this.searchForm.type,
                'themeLevelCode':this.searchForm.level,
                'blockName':this.searchForm.blockName,
                'themeId':this.themeId,
            }

            let res = await gameplanApi.getGamepalnTimechange(params);
            if (res.data.resultCode == '0') {
                let data = res.data.resultData
                this.searchForm.page = data.pageInfo.curPage
                this.searchForm.total = data.pageInfo.totalCounts
                // this.buOptions = data.buCodeMap
                // this.regionOptions = data.regionCodeMap
                // this.cityOptions = data.areaCodeMap
                // this.channelOptions = data.themeChannelCodeMap
                // this.typeOptions = data.themeStyleCodeMap
                // this.levelOptions = data.themeLevelCodeMap
                // this.blockOptions = data.blockNameSet
                if (data.activityPocList !== null) {
                    let cardData = data.activityPocList
                    for (let item of cardData) {
                        let oldTimelist = []
                        let newTimelist = []
                        if (item.gpActivityTimeDTOList !== null) {
                            for (let item2 of item.gpActivityTimeDTOList) {
                                oldTimelist.push(item2.activityTime)
                            }
                        }
                        if (item.waitApprovalTimeDTOList !== null) {
                            for (let item2 of item.waitApprovalTimeDTOList) {
                                newTimelist.push(item2.activityTime)
                            }
                        }
                        item.oldTimelist = oldTimelist
                        item.newTimelist = newTimelist
                        // item.isChecked = true
                        item.isChecked = false
                    }
                    this.cardData = cardData
                    // this.isIndeterminate = false
                    // this.checkAll = true
                    this.isIndeterminate = false
                    this.checkAll = false
                } else {
                    this.cardData = []
                }
            } else {
                console.log('接口error');
            }
        },
        timeChangeapproval (params) {
            this.loading = true
            gameplanApi.timeChangeapproval(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.loading = false
                    if (params.processAction == '02') {
                        this.$message.success('日期修改申请已通过');
                    } else if (params.processAction == '03') {
                        this.$message.success('日期修改申请已拒绝');
                    }
                    this.getActivityreturn()
                    this.rejectAccount = ''
                } else {
                    console.log('error');
                    this.loading = false
                }
            })
        },
        // 搜索
        queryForm (val) {
            this.searchForm.page = 1
            this.getActivityreturn()
        },
        // 重置
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.page = 1
            this.getActivityreturn()
        },
        // 同意
        agree (item) {
            // console.log(item,'item');
            // console.log(item.gpThemeDetailDTO.needSpr,'needSpr');
            let arr = []
            arr.push(item.timeApprovalId)
            let params =
                {
                    'processAction': '02',
                    'timeApprovalList':arr,
                }
            // console.log(params,'agree');
            if (item.gpThemeDetailDTO.needSpr == '1') {
                let that = this
                let gpParams = {
                    'activityId': item.activityId,
                    'newTimeList':item.timeApprovalDTO.timeNewList
                }
                function callerFun(){
                    gameplanApi.queryGpactivitydatail(gpParams).then((res) =>{
                        let data = res
                        if (data) {
                            that.$confirm('是否确认同意申请?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                that.timeChangeapproval(params)
                            }).catch(() => {})
                        }
                    })
                }
                callerFun()
            } else {
                this.timeChangeapproval(params)
            }
        },
        // 拒绝
        disagree (item) {
            let arr = []
            arr.push(item.timeApprovalId)
            let params =
                {
                    'processAction': '03',
                    'timeApprovalList':arr,
                    'timeRejectReason':this.rejectAccount,
                    'timeRejectPerson':this.userInfo.clientName,
                }
            this.timeChangeapproval(params)
            // console.log(params,'disagree');
        },
        // 批量通过
        agreeAll () {
            let arr = []
            for (let item of this.cardData) {
              if (item.isChecked == true) {
                  arr.push(item.timeApprovalId)
              }
            }
            if (arr.length == 0) {
              this.$message.warning('未选择门店/街区')
              return
            }
            let params = {
              'processAction': '02',
              'timeApprovalList':arr,
            }
            // console.log(params,'agree');
            // console.log(arr,'批量通过');
            this.timeChangeapproval(params)

        },
        // 批量拒绝
        disagreeAll () {
            let arr = []
            for (let item of this.cardData) {
                if (item.isChecked == true) {
                    arr.push(item.timeApprovalId)
                }
            }
            if (arr.length == 0) {
              this.$message.warning('未选择门店/街区')
              return
            }
            let params = {
              'processAction': '03',
              'timeApprovalList':arr,
              'timeRejectReason':this.rejectAccount,
              'timeRejectPerson':this.userInfo.clientName,
            }
            // console.log(params,'disagreeAll');
            // console.log(arr,'批量拒绝');
            this.timeChangeapproval(params)
        },
        //单选
        changeItem (item) {
            // console.log(item,'单选');
            // isShowsome 未全选  isShowall 全选  isShownone 全不选
            let isShowsome =  this.cardData.some(item=>{
                return item.isChecked == false
            })
            let isShowall =  this.cardData.every(item=>{
                return item.isChecked == true
            })
            let isShownone =  this.cardData.every(item=>{
                return item.isChecked == false
            })
            if (isShowall) {
                this.isIndeterminate = false
                this.checkAll = true
            } else if(isShownone) {
                this.isIndeterminate = false
                this.checkAll = false
            } else if(isShowsome) {
                this.isIndeterminate = true
                this.checkAll = false
            }
        },
        //全选
        handleCheckAllChange () {
             // isHavefasle 判断是否有至少一个勾选 isShowsome 未全选  isShowall 全选  isShownone 全不选
             let isHavefasle =  this.cardData.some(item=>{
                return item.isChecked == false
            })
            if (isHavefasle) {
                for (let item of this.cardData) {
                    item.isChecked = true
                }
            } else {
                for (let item of this.cardData) {
                    item.isChecked = !item.isChecked
                }
            }
            let isShowsome =  this.cardData.some(item=>{
                return item.isChecked == false
            })
            let isShowall =  this.cardData.every(item=>{
                return item.isChecked == true
            })
            let isShownone =  this.cardData.every(item=>{
                return item.isChecked == false
            })
            if (isShowall) {
                this.isIndeterminate = false
                this.checkAll = true
            } else if(isShownone) {
                this.isIndeterminate = false
                this.checkAll = false
            } else if(isShowsome) {
                this.isIndeterminate = true
                this.checkAll = false
            }
        },
      }
    }
</script>
<style lang="scss">
    .elDatePicker2 {
        .el-date-table td.selected span {
            background-color: #cd1231;
            color: #FFF;
            border-radius: 15px;
        }
        .el-picker-panel__footer {
            display: none;
        }
    }
    .elDatePicker1 {
        .el-date-table td.selected span {
            // background-color: rgb(222, 101, 45);
            color: #FFF;
            border-radius: 15px;
        }
        .el-picker-panel__footer {
            display: none;
        }
    }
</style>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .card-top {
        line-height: 20px;
        border-radius: 10px;
        padding: 10px 20px;
        margin-bottom: 30px;
        font-size: 14px;
        text-align: center;
        background-color: #FFFFFF;
        color: #101010;
        font-family: Roboto;
        display: flex;
        justify-content: flex-start;
        .card-top-left {
            flex: 1;
            .top {
                line-height: 29px;
                color: #101010;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                margin-bottom: 5px;
                word-wrap: break-word;
                word-break: normal;
                word-break: break-all;
            }
            .bottom {
                display: flex;
                justify-content: flex-start;
                .left {
                    font-size: 16px;
                    margin-right: 11px;
                    line-height: 24px;
                }
                .right {
                    line-height: 14px;
                    padding: 3px 10px;
                    margin-top: 2px;
                    border-radius: 4px;
                    font-size: 14px;
                    background-color: #FFFFFF;
                    color: #539EFE;
                    border: 1px solid #539EFE;
                    text-align: center;
                }
            }
        }
        .card-top-right {
            width: 30%;
            text-align: right;
            line-height: 20px;
            margin-top: 40px;
            color: #999999;
        }
    }
      .search {
        .searchForm {
            width: 100%;
            display: flex;
            // justify-content: space-between;
            .item {
                width:120px;
                text-align: center;
            }
            .item-btn {
                display: flex;
                justify-content: flex-end;
                flex: 1;
            }
        }
    }
    .item-select {
        line-height: 30px;
        height: 30px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #cd1231;
        }
        .select-btn {
            display: flex;
            margin: auto;
            margin-right: 10px;
        }

    }
    .card-select {
        margin-bottom: 30px;
        font-size: 14px;
        text-align: left;
        color: #101010;
        display: flex;
        .card-left {
            display: flex;
            flex-flow: column;
            justify-content: center;
            .left-select {
                margin-right: 15px;
            }
        }
        .card-right {
            flex: 1;
            .top {
                display: flex;
                .top-left {
                    color: #101010;
                    font-size: 16px;
                    font-weight: 600;
                    margin-right: 10px;
                    line-height: 29px;
                    word-wrap: break-word;
                    word-break: normal;
                    word-break: break-all;
                }
                .top-left2 {
                    text-align: left;
                    .name-boc {
                        font-size: 16px;
                        font-weight: 600;
                        color: #101010;
                        line-height: 29px;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                    .name-poc {
                        font-size: 14px;
                        color: #cd1231;
                        line-height: 29px;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
            }
            .second {
                display: flex;
                line-height: 29px;
                color: rgba(16, 16, 16, 1);
                font-size: 14px;
                text-align: left;
                .center {
                    margin-left: 10px;
                }
                .line {
                    margin: 0 10px;
                }
            }
            .last {
                display: flex;
                flex-wrap: wrap;
                // line-height: 29px;
                .last-left {
                    color: #539EFE;
                    line-height: 29px;
                }

                .last-center {
                    .last-center1 {
                        display: flex;
                        .item-img {
                            .img-item {
                                margin-right: 5px;
                                margin-bottom: 5px;
                                width: 64px;
                                cursor: pointer;
                                overflow:hidden;
                                max-height: 64px;
                                .img {
                                    width:100%;
                                    height:100%;
                                    background-position:center center;
                                    background-repeat: no-repeat;
                                    -webkit-background-size:cover;
                                    -moz-background-size:cover;
                                    background-size:cover;
                                }
                            }
                        }
                        .item-time {
                            display: flex;
                            color: #539EFE;
                            line-height: 32px;
                            margin-right: 100px;
                            .item-left {
                                padding: 0px 5px 0px 0px;
                                line-height: 20px;
                                line-height: 32px;
                            }
                            .item-right {
                                flex: 1;
                                display: flex;
                                flex-wrap: wrap;
                                .item-text {
                                    padding: 0px 5px;
                                    border: 1px solid #539EFE;
                                    border-radius: 2px;
                                    margin-right: 3px;
                                    margin-bottom: 3px;
                                }
                            }
                        }
                    }
                }
                .last-right {
                    // height: 29px;
                    margin: auto 0;
                    line-height: 29px;
                    flex: 1;
                    display: flex;
                    justify-content: flex-end;
                    font-size: 14px;
                    text-align: center;
                    .btn-right {
                        width: 84px;
                        text-align: center;
                        background-color: #FFFFFF;
                        color: #cd1231;
                        border-radius: 5px;
                        border: 1px solid #cd1231;
                        cursor: pointer;
                        height: 29px;
                        line-height: 29px;
                        margin-right: 10px;
                    }
                }
            }
        }
        .card-item {
            border-radius: 10px;
            padding: 10px 10px 10px 20px;
            font-size: 14px;
            text-align: left;
            background-color: #FFFFFF;
            color: #101010;
        }
    }
    .pagination {
        position: relative;
        bottom: 0;
        text-align: center;
    }
    }
</style>
